/**
 * Created by lari on 26/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('fieldgroup', {
      restrict: 'E',
      bindings: {
        fieldgroup: '=',
        gi: '@',
        onFieldgroupChange: '&'
      },
      templateUrl: 'vcexam/fieldgroup-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          
          function save() {
            $log.debug('fieldgroup.save called: ', vm.fieldgroup.label);
            vm.onFieldgroupChange();
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());
